import {
    BaseUpdateComponent,
    BaseDataService,
    ModalService,
    NotificationService,
    ErrorHandlerService,
} from 'yt-ng-framework';

import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { EOtpremnicaOpasnaMaterija } from './eotpremnica-opasna-materija';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'yt-eotpremnica-opasna-materija-update',
    templateUrl: './eotpremnica-opasna-materija-update.component.html'
})
export class EOtpremnicaOpasnaMaterijaUpdateComponent
    extends BaseUpdateComponent<EOtpremnicaOpasnaMaterija>
    implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    izlazna: boolean = true;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected errorService: ErrorHandlerService
    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService);
    }

    ngOnInit() {
        super.ngOnInit();

        if (this.Parameters && this.Parameters.get(1))
            this.izlazna = Boolean(this.Parameters.get(1).get(0).Value);


        this.addValidatorToFc('Naziv', Validators.required, 'required', 'EOTPREMNICA.OPASNAMATERIJA.NAZIV.VALIDATION.REQUIRED');
        this.addValidatorToFc('Vrednost', Validators.required, 'required', 'EOTPREMNICA.OPASNAMATERIJA.VREDNOST.VALIDATION.REQUIRED');
        
        //this.addValidatorToFc('EOtpremnicaID', Validators.required, 'required', 'EOTPREMNICA.ID.REQUIRED');
         
        this.IDProcessed
            .subscribe((value) => {

                if(value){
                  
                  if (!Boolean(this.Parameters.get(1).get(0).Value)){
                        this.baseFormGroup.disable();
                        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
                    }
                 
                }
                
            })       

    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
